import * as actions from "./actions";
import * as constants from "./constants";
import reducer from "./reducer";
import * as sagas from "./sagas";

import ViewReportContainer from "./components/ViewReport";

export { ViewReportContainer, reducer, constants, sagas, actions };

export default {
  constants,
  reducer,
  sagas,
  actions,
  ViewReportContainer
};



// WEBPACK FOOTER //
// ./client/modules/Report/index.ts